"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("../../fields/Checkbox/Checkbox"));

var _CheckboxGroup = _interopRequireDefault(require("../../fields/CheckboxGroup/CheckboxGroup"));

var _Date = _interopRequireDefault(require("../../fields/Date/Date"));

var _Ethnicity = _interopRequireDefault(require("../../fields/Ethnicity/Ethnicity"));

var _Gender = _interopRequireDefault(require("../../fields/Gender/Gender"));

var _Radio = _interopRequireDefault(require("../../fields/Radio/Radio"));

var _Select = _interopRequireDefault(require("../../fields/Select/Select"));

var _Textarea = _interopRequireDefault(require("../../fields/Textarea/Textarea"));

var _Textfield = _interopRequireDefault(require("../../fields/Textfield/Textfield"));

var _types = require("../../types");

var _fieldsetConfig = require("./fieldsetConfig");

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _fieldConfigs = require("../../fields/config/fieldConfigs");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var CheckboxDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.CheckboxDefinition;
});

var CheckboxGroupDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.CheckboxGroupDefinition;
});

var DateDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.DateDefinition;
});

var EthnicityDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.EthnicityDefinition;
});

var GenderDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.GenderDefinition;
});

var RadioDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.RadioDefinition;
});

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.SelectDefinition;
});

var TextareaDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.TextareaDefinition;
});

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.TextfieldDefinition;
});

var FieldsetDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldsetConfig.FieldsetDefinition;
});

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("fieldset", _flowRuntime["default"].ref(FieldsetDefinition))));

var _default = function _default(_arg) {
  var fieldset = _arg.fieldset;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "fields"
  }, fieldset.fields && fieldset.fields.map(function (field) {
    switch (field.type) {
      case _fieldConfigs.checkboxConfig.type:
        {
          return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            key: field.key,
            checkbox: field
          });
        }

      case _fieldConfigs.checkboxGroupConfig.type:
        {
          return /*#__PURE__*/_react["default"].createElement(_CheckboxGroup["default"], {
            key: field.key,
            checkboxGroup: field
          });
        }

      case _fieldConfigs.currencyConfig.type:
      case _fieldConfigs.numberConfig.type:
      case _fieldConfigs.emailConfig.type:
      case _fieldConfigs.telephoneConfig.type:
      case _fieldConfigs.textfieldConfig.type:
        {
          return /*#__PURE__*/_react["default"].createElement(_Textfield["default"], {
            inheritedFieldValidation: fieldset.inheritedFieldValidation,
            key: field.key,
            textfield: field
          });
        }

      case _fieldConfigs.dateConfig.type:
        {
          return /*#__PURE__*/_react["default"].createElement(_Date["default"], {
            date: field,
            inheritedFieldValidation: fieldset.inheritedFieldValidation,
            key: field.key,
            parentKey: fieldset.key
          });
        }

      case _fieldConfigs.ethnicityConfig.type:
        {
          return /*#__PURE__*/_react["default"].createElement(_Ethnicity["default"], {
            ethnicity: field,
            inheritedFieldValidation: fieldset.inheritedFieldValidation,
            key: field.key,
            parentKey: fieldset.key
          });
        }

      case _fieldConfigs.genderConfig.type:
        {
          return /*#__PURE__*/_react["default"].createElement(_Gender["default"], {
            gender: field,
            inheritedFieldValidation: fieldset.inheritedFieldValidation,
            key: field.key,
            parentKey: fieldset.key
          });
        }

      case _fieldConfigs.radioConfig.type:
        {
          return /*#__PURE__*/_react["default"].createElement(_Radio["default"], {
            inheritedFieldValidation: fieldset.inheritedFieldValidation,
            key: field.key,
            radio: field
          });
        }

      case _fieldConfigs.selectConfig.type:
        {
          return /*#__PURE__*/_react["default"].createElement(_Select["default"], {
            inheritedFieldValidation: fieldset.inheritedFieldValidation,
            key: field.key,
            select: field
          });
        }

      case _fieldConfigs.textareaConfig.type:
        {
          return /*#__PURE__*/_react["default"].createElement(_Textarea["default"], {
            inheritedFieldValidation: fieldset.inheritedFieldValidation,
            key: field.key,
            textarea: field
          });
        }

      default:
        // eslint-disable-next-line no-console
        console.warn('Unknown field type: ', field.type);
        return null;
    }
  }));
};

exports["default"] = _default;